import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { PageNotFoundComponent } from './_share/page-not-found/page-not-found.component';
import { AuthGuard } from './_helpers/auth.guard';

const routes: Routes = [
  { 
    path: '',
    component: DashboardComponent, 
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { page: 'main-dashboard' }
  },
  {
    path: 'dashboard', 
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { page: 'main-dashboard' }
  },
  { path: 'login', component: LoginComponent },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
